<script>
import moment from "moment";
import StepItem from "./StepItem.vue";
export default {
  name: "TimeLine",
  components: { StepItem },
  props: ["stepsKey"],
  data() {
    return {
      eventDay: moment("07-07-2025", "DD-MM-YYYY"),
      launchDay: moment("22-04-2025", "DD-MM-YYYY"),
      referencePoint: moment("20-04-2025", "DD-MM-YYYY"),
      currentProgress: 0,
      diffDays: 0,
      isStepReached: false,
      steps: [
        {
          title: "",
          date: "20-04-2025",
          display_date: "20-04-2025",
          visible: false,
        },
        {
          title: "Registration<br>opens",
          date: "22-04-2025",
          display_date: "22/04/25",
        },
        {
          title: "Qualifier 1",
          date: "02-05-2025",
          display_date: "From 02 to 09/05/25",
        },
        {
          title: "Qualifier 2",
          date: "15-05-2025",
          display_date: "From 15 to 22/05/25",
        },
        {
          title: "Qualifier 3",
          date: "10-06-2025",
          display_date: "From 03 to 15/06/25",
        },
        {
          title: "Finals",
          date: "02-07-2025",
          display_date: "From 02 to 06/07/25",
        },
      ],
      timelines: {
        home: [
          {
            title: "",
            date: "22-04-2025",
            display_date: "20-04-2025",
            visible: false,
          },
          {
            title: "Registration<br>opens",
            date: "22-04-2025",
            display_date: "22/04/25",
          },
          {
            title: "Qualifier 1",
            date: "02-05-2025",
            display_date: "From 02 to 09/05/25",
          },
          {
            title: "Qualifier 2",
            date: "15-05-2025",
            display_date: "From 15 to 22/05/25",
          },
          {
            title: "Qualifier 3",
            date: "10-06-2025",
            display_date: "From 03 to 15/06/25",
          },
          {
            title: "Finals",
            date: "02-07-2025",
            display_date: "From 02 to 06/07/25",
          },
        ],
        "free-fire": [
          {
            title: "",
            date: "20-04-2025",
            display_date: "20-04-2025",
            visible: false,
          },
          {
            title: "Qualifier 1",
            date: "02-05-2025",
            display_date: "From 02 to 04/05/25",
          },
          {
            title: "Qualifier 2",
            date: "16-05-2025",
            display_date: "From 15 to 17/05/25",
          },
          {
            title: "Qualifier 3",
            date: "06-06-2025",
            display_date: "From 03 to 10/06/25",
          },
          {
            title: "Finals",
            date: "02-07-2025",
            display_date: "02 & 03/07/25",
          },
        ],
        eafc25: [
          {
            title: "",
            date: "20-04-2025",
            display_date: "20-04-2025",
            visible: false,
          },
          {
            title: "Qualifier 1",
            date: "04-05-2025",
            display_date: "From 04 to 06/05/25",
          },
          {
            title: "Qualifier 2",
            date: "17-05-2025",
            display_date: "From 17 to 19/05/25",
          },
          {
            title: "Qualifier 3",
            date: "06-06-2025",
            display_date: "From 03 to 12/06/25",
          },
          {
            title: "Finals",
            date: "04-07-2025",
            display_date: "04 & 05/07/25",
          },
        ],
        valorant: [
          {
            title: "",
            date: "20-04-2025",
            display_date: "20-04-2025",
            visible: false,
          },
          {
            title: "Qualifier 1",
            date: "06-05-2025",
            display_date: "From 06 to 08/05/25",
          },
          {
            title: "Qualifier 2",
            date: "19-05-2025",
            display_date: "From 19 to 21/05/25",
          },
          {
            title: "Qualifier 3",
            date: "08-06-2025",
            display_date: "From 03 to 14/06/25",
          },
          {
            title: "Finals",
            date: "05-07-2025",
            display_date: "05 & 06/07/25",
          },
        ],
        "street-fighter": [
          {
            title: "",
            date: "20-04-2025",
            display_date: "20-04-2025",
            visible: false,
          },
          {
            title: "Qualifier 1",
            date: "08-05-2025",
            display_date: "From 08 to 09/05/25",
          },
          {
            title: "Qualifier 2",
            date: "21-05-2025",
            display_date: "From 21 to 22/05/25",
          },
          {
            title: "Qualifier 3",
            date: "10-06-2025",
            display_date: "From 03 to 15/06/25",
          },
          { title: "Finals", date: "04-07-2025", display_date: "04/07/25" },
        ],
      },
      isMobileView: window.innerWidth < 576,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    daysToEventDay() {
      return moment
        .duration(this.eventDay.add(1, "days").diff(this.referencePoint))
        .asDays();
    },
    layoutStyle() {
      if (this.isMobileView) {
        return {
          flexDirection: "column",
          width: "8px",
        };
      } else {
        return {
          flexDirection: "row",
          height: "8px",
          width: "100%",
        };
      }
    },
    progressStyle() {
      if (this.isMobileView) {
        return {
          height: `${this.currentProgress + 1}%`,
          width: "100%",
          //background: 'linear-gradient(180deg, rgba(250,70,36,1) 0%, rgba(250,70,36,0) 100%)',
        };
      } else {
        return {
          width: `${this.currentProgress + 1}%`,
          height: "100%",
          //background: 'linear-gradient(90deg, rgba(250,70,36,1) 0%, rgba(250,70,36,0) 100%)',
        };
      }
    },
  },
  watch: {
    windowWidth: (newVal, oldVal) => {
      console.log("window width changed ....");
      this.handleResize();
    },
  },
  methods: {
    getCurrentTimeLine(name = "home") {
      this.steps = Object.assign({}, this.timelines[name]);
    },
    getCurrentProgress() {
      this.diffDays = Math.floor(
        moment.duration(this.eventDay.diff(moment())).asDays()
      );
      this.currentProgress = Math.abs(
        (Math.floor(
          moment.duration(this.referencePoint.diff(moment())).asDays()
        ) /
          this.daysToEventDay) *
          100
      ); // percentage
    },
    dateToPercentage(stepDate) {
      console.log(
        "stepDate: ",
        stepDate,
        Math.abs(
          Math.floor(
            moment
              .duration(
                this.referencePoint.diff(moment(stepDate, "DD-MM-YYYY"))
              )
              .asDays()
          )
        )
      );
      return Math.abs(
        (Math.floor(
          moment
            .duration(this.referencePoint.diff(moment(stepDate, "DD-MM-YYYY")))
            .asDays()
        ) /
          this.daysToEventDay) *
          100
      );
    },
    handleResize() {
      console.log("window:width:size: ", window.innerWidth);
      this.isMobileView = window.innerWidth < 576;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.getCurrentTimeLine(this.stepsKey);
    this.getCurrentProgress();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<template>
  <div class="container">
    <div>
      <h2 class="timeline-title text-white p-0 m-0" dir="auto">Timeline</h2>
    </div>
    <div class="wrapper my-5 d-flex align-items-center w-100">
      <div
        class="timeline-wrapper position-relative"
        :class="{ 'mx-5': isMobileView }"
        :style="layoutStyle"
      >
        <div
          class="timeline-progress-bar d-flex align-items-center justify-content-start position-relative"
          :style="{ flexDirection: layoutStyle.flexDirection }"
        >
          <div class="timeline-progress" :style="progressStyle"></div>
          <!--<div class="timeline-steps-container position-absolute w-100 h-100">

          </div> -->
        </div>
        <StepItem
          v-for="step in steps"
          :key="step.date + $route.name"
          :visible="step.visible"
          :percentage="dateToPercentage(step.date)"
          :time-line-percentage="currentProgress"
          :step="step"
          :vertical="isMobileView"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.timeline-title {
  font-family: "sqwaredsemi_bold" !important;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 1);
}
.wrapper {
  min-height: 160px;
}
.timeline-wrapper {
  height: 8px;
}
.timeline-progress-bar {
  background: var(--forground-bg-color);
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
}
.timeline-progress {
  background: var(--main-color);
  /* background: linear-gradient(90deg, rgba(250, 70, 36, 1) 0%, rgba(250, 70, 36, 0.9) 80%, rgba(250, 70, 36, 0.56) 90%, rgba(250, 70, 36, 0) 100%);*/
}
.timeline-steps-container {
  left: 0;
  top: 0;
}
/* ========== RESPONSIVE MOBILE VIEW ========== */
@media (max-width: 575.98px) {
  .wrapper {
    min-height: auto;
    flex-direction: column;
    align-items: flex-start !important;
  }

  .timeline-wrapper {
    width: 8px;
    min-height: 300px; /* adjust based on content */
  }
  .timeline-progress {
    width: 100%;
    /* background: linear-gradient(
        180deg,
        rgba(250, 70, 36, 1) 0%,
        rgba(250, 70, 36, 0.9) 80%,
        rgba(250, 70, 36, 0.56) 98%,
        rgba(250, 70, 36, 0) 100%
    );*/
  }

  .timeline-steps-container {
    flex-direction: column;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
